import { cleanRepeatedTrailingChars, toBool, toVerificationMode } from '@/shared/utils/mapping';
import type { AccessRoleDTO } from '../dto/AccessRoleDTO';
import type { AccessRole, VerificationMode, StructureInfo } from '../../domain/entities/AccessRole';

function formatTypeLabel(type: string): string {
  if (type === 'TIME_ATTENDANCE') return 'Control de asistencia';
  return type
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function toAccessRole(dto: AccessRoleDTO): AccessRole {
  const modes = dto.verificationModeInfo
    .map((v) => toVerificationMode(v.verification_mode))
    .filter((m): m is VerificationMode => m !== 'unknown');

  const structuresInfo: StructureInfo[] = dto.structuresInfo.map((s) => ({
    idStructure: s.id_structure,
    code: s.code,
    path: s.path,
    structure: s.structure,
    idTimezone: s.id_timezone,
    idStructureType: s.id_structure_type,
    timezonePg: s.timezone_pg,
  }));

  return {
    idAccessRole: dto.id_access_role,
    name: cleanRepeatedTrailingChars(dto.name_access_role),
    typeLabel: formatTypeLabel(dto.type_access_role),
    employeeCount: dto.employees,
    isActive: toBool(dto.status),
    verificationModes: modes,
    idMarkingRole: dto.id_marking_role,
    structures: dto.structures,
    structuresInfo,
  };
}
